const NumberOperator = {
  EQUALS: {label: "equals", value: "eq" },
  NOT_EQUALS: { label: "not equals", value: "ne" },
  LESS_THAN: { label: "less than", value: "lt" },
  LESS_THAN_EQUALS: { label: "less than or equals", value: "lte" },
  GREATER_THAN: { label: "greater than", value: "gt" },
  GREATER_THAN_EQUALS: { label: "greater than or equals", value: "gte" },
  IS_EMPTY: { label: "is empty", value: "isEmpty" },
  IS_NOT_EMPTY: { label: "is not empty", value: "isNotEmpty" },
  IN: {label: "in", value: "in" },
};

const StringOperator = {
  IN: { label: "in", value: "in" },
  CONTAINS: {label: "contains", value: "contains" },
  DOES_NOT_CONTAIN: {label: "does not contain", value: "notContains" },
  STARTS_WITH: {label: "starts with", value: "startsWith" },
  ENDS_WITH: {label: "ends with", value: "endsWith" },
  REGEXP: {label: "regular expression", value: "regExp" },
  IS_EMPTY: { label: "is empty", value: "isEmpty" },
  IS_NOT_EMPTY: { label: "is not empty", value: "isNotEmpty" }
};

const BooleanOperator = {
  IN: {label: "in", value: "in" },
  NOT_IN: {label: "not in", value: "notIn"},
  IS_EMPTY: { label: "is empty", value: "isEmpty" },
  IS_NOT_EMPTY: { label: "is not empty", value: "isNotEmpty" }
};

const DateOperator = {
  ON: {label: "on", value: "on" },
  FROM: {label: "from", value: "from" },
  UNTIL: {label: "until", value: "until" },
  IS_EMPTY: { label: "is empty", value: "isEmpty" },
  IS_NOT_EMPTY: { label: "is not empty", value: "isNotEmpty" }
};

const EnumOperator = {
  IN: { label: "in", value: "in" },
  NOT_IN: { label: "not in", value: "notIn" },
  IS_EMPTY: { label: "is empty", value: "isEmpty" },
  IS_NOT_EMPTY: { label: "is not empty", value: "isNotEmpty" }
};

module.exports = Object.freeze({
  NumberOperator,
  StringOperator,
  DateOperator,
  BooleanOperator,
  EnumOperator
});
